import { useEffect } from "react";

import { useUser } from "@js/apps/common/hooks";

import { useGetOrCreateMessageRoomMutation } from "../api";

type UseGetOrCreateRoomTypes = {
  receiverUserId?: number;
  senderUserId?: number;
  isApplicationRejectRequest?: boolean;
  jobId?: number;
  contentType?: EnumType<typeof ENUMS.RoomTypeContentType>;
};

export const useGetOrCreateRoom = ({
  receiverUserId,
  senderUserId,
  jobId,
  contentType,
  isApplicationRejectRequest,
}: UseGetOrCreateRoomTypes) => {
  const [
    getOrCreateMessageRoom,
    { isLoading: isGetOrCreateMessageRoomLoading, data: room, error },
  ] = useGetOrCreateMessageRoomMutation();
  const { id: userId } = useUser() || {};

  const senderId = senderUserId || userId;
  useEffect(() => {
    if (!senderId || !receiverUserId) return;
    void getOrCreateMessageRoom({
      context: {
        participants: [senderId, receiverUserId],
        initiated_by_application_reject_request: isApplicationRejectRequest
          ? true
          : undefined,
      },
      jobId,
      contentType,
    });
  }, [
    senderId,
    isApplicationRejectRequest,
    receiverUserId,
    getOrCreateMessageRoom,
    jobId,
    contentType,
  ]);

  return {
    isLoading: isGetOrCreateMessageRoomLoading,
    room,
    error,
  };
};
